var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYandex = function SvgIconYandex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-yandex_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-yandex_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 0H0v24h24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-yandex_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-yandex_svg__c)",
    d: "M0 5.053C0 2.263 2.149 0 4.8 0h14.4C21.85 0 24 2.262 24 5.053v7.575H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-yandex_svg__d)",
    d: "M0 12.628h12V24H4.8C2.149 24 0 21.737 0 18.947z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-yandex_svg__e)",
    d: "M12 12.628h12v6.319C24 21.737 21.85 24 19.2 24H12z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-yandex_svg__c",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 12.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-yandex_svg__d",
    x1: 6,
    x2: 6,
    y1: 12.628,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-yandex_svg__e",
    x1: 18,
    x2: 18,
    y1: 12.628,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353638"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-yandex_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconYandex;